import React from "react";
import Successicon from "../assets/images/Successicon.png";
import { Link, useLocation } from "react-router-dom";
import WhyTrust from '../layout/WhyTrust';
import Header from "../components/Header";
import Footer from "../components/Footer";

function ThankYou() {
  const location = useLocation();
  const orderNo = location.state?.orderNo;

  return (
    <>
      <Header />
      <div className="thanku-outer">
        <div className="container">
          <img src={Successicon} alt="" className="img-fluid" />
          <h1>Thank You for Your Booking!</h1>
          {orderNo && (
            <h3 style={{ color: "#13baac", margin: "15px 0", fontWeight: "700" }}>
              Order Number: {orderNo}
            </h3>
          )}
          <Link to="/">Back to Home</Link>
        </div>
      </div>
      <WhyTrust />
      <Footer />
    </>
  );
}

export default ThankYou;
